<template>
    <div class="bg" id="pay">

        <v-alert v-model="falert"
                 border="left"
                 close-text="Close Alert"
                 type="error"
                 dark
                 dismissible>
           An error occured during the process, although we might have gotten your payment.
        </v-alert>

        <v-alert v-model="salert"
                 border="left"
                 close-text="Close Alert"
                 type="success"
                 dark
                 dismissible>
          Thanks for supporting us to reclaim Nigeria
        </v-alert>
        <v-form ref="form1" method="post" data-vv-scope="form1" @submit.stop.prevent="handleSubmit()"  class="pa-md-12 "
                lazy-validation>
            <v-row class="px-8 pt-12">
                <v-col md="4" sm="12" xs="12" cols="12">
                    <v-text-field v-validate="'required|email'" data-vv-name="email" dark filled style="border-color:white;" color="white" class="white--text" :error-messages="errors.collect('form1.email')" v-model="model.email" outlined :type="'text'"
                                  label="Email Address"></v-text-field>
                </v-col>
                <v-col md="4" class="" sm="12"  xs="12" cols="12">
                    <v-text-field v-validate="'required'" data-vv-name="name" dark filled style="border-color:white;" color="white" class="white--text" :error-messages="errors.collect('form1.name')" v-model="model.name"  outlined :type="'text'"
                                  label="Name"></v-text-field>

                </v-col>
                <v-col md="4" sm="12" xs="12" cols="12" >
                    <v-text-field v-model="model.phone" v-validate="'required|min:11|max:11'" dark filled style="border-color:white;" color="white" class="white--text" data-vv-name="phoneNumber" outlined  :error-messages="errors.collect('form1.phoneNumber')"
                                  label="Phone Number" :type="'number'"></v-text-field>
                </v-col>

            </v-row>
            <v-row class="px-8 pb-12">
                <v-col md="4" sm="12" xs="12" cols="12">
                    <v-text-field v-model="model.sponsor" dark filled style="border-color:white;" color="white" class="white--text" v-validate="'min:11|max:11'" data-vv-name="refferalNumber" outlined :error-messages="errors.collect('form1.refferalNumber')"
                                  :type="'number'" label="Refferal Phone number">


                    </v-text-field>
                   
                </v-col>
                <v-col md="4" sm="12" xs="12" cols="12" >
                    <v-text-field v-validate="'required|min_value:2000'" data-vv-name="amount" dark filled style="border-color:white;" color="white" class="white--text" :error-messages="errors.collect('form1.amount')" v-model="model.amount"  outlined :type="'number'"
                                  label="Amount"></v-text-field>

                </v-col>
                <v-col md="4" sm="12" xs="12" cols="12" >
                    <v-btn x-large type="'submit'" style="width:100%;" depressed class="blue--text text-center white " large>Pay Now</v-btn>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>


<script>
    require('../plugins/ravepay');
    import { TokenService } from '@/services/storage.service'
    import { CoreService } from '@/services/core.service'
 
  
    export default {
        $_veeValidate: {
            validator: 'new',
        },
        data: () => ({
           
            selectedAddress: {},
            salert: false,
            falert:false,
            model: {
                name: '',
               
                email: '',
               
                phone: '',
              
                sponsor: '',
                amount: 0,
            }
          


          
        }),
        computed: {


            formattedWalletBalance() {
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'NGN',
                    minimumFractionDigits: 2
                })
                return formatter.format(this.walletBalanche[0]);
            },
        },
        methods: {

           




            
            GetRandomNo() {
                var length = 5;
                var result = '';
                var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                var charactersLength = characters.length;
                for (var i = 0; i < length; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength));
                }
                return result;
            },

            async finalizeOrder(data) {
                //console.log(data);
                var k = await CoreService.PlaceOrder(this.model.name, parseFloat(this.model.amount), this.model.phone, data.tx.id.toString(), this.model.sponsor, this.model.email)
                if (k) {
                    this.salert = true;

                    this.falert = false;
                }
                else {
                    this.falert = true;
                    this.salert = false;
                }

            },

            Pay() {




                var PBFKey = "FLWPUBK-b56f272fa72cd8cecc8b6438304b5909-X";



                window.getpaidSetup({
                    customer_email: this.model.email,
                    PBFPubKey: PBFKey,
                    customer_firstname: this.model.name,
                    custom_title: "Ayoola 2023 Campaign Funding ",
                    country: "NG",
                    currency: "NGN",
                    amount: this.model.amount,
                    customer_phone: this.model.phone,
                   
                    txref: this.GetRandomNo(),
                    onclose: async function () {



                        //this.finalizeOrder(ordt);

                    }.bind(this),
                    callback: function (data) {


                        this.finalizeOrder(data);

                    }.bind(this)
                })

            },


          
            async handleSubmit() {

                var self = this;
                this.$validator.validateAll('form1').then(async function (result) {

                    if (result) {

                        self.Pay();


                    }
                    if (!result) {
                        console.log('Oops!');
                    }
                })

            },


        },
        beforeMount() {



           
        },
    }
</script>


<style scoped>
    .bg {
        width: 100%;
        min-height: 325px;
        background-image: linear-gradient(262.2deg, #2E368F -90.39%, #2AACE2 141.93%);
        background-repeat: no-repeat, no-repeat, no-repeat;
        background-position: bottom right, left, right;
    }
</style>